/* tslint:disable */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'
import { NavLink } from 'react-router-dom'

export class CustomNavLink extends React.Component<any, any> {
    render() {

        let urlLastSplit = window.location.href.split('/')[
            window.location.href.split('/').length - 1
        ]

        let isActive = false

        if (urlLastSplit === "dashboard" && this.props.dashboard) {
            isActive = true
        } else if (urlLastSplit !== "dashboard" && !this.props.dashboard) {
            isActive = true
        }

        return <NavLink
            strict
            to={this.props.to}
            className={(this.props.className) ? this.props.className : "menuItem"}
            activeClassName={(this.props.activeClassName) ?
                this.props.activeClassName : ((isActive) ? "active" : "")}>
            {this.props.children}
        </NavLink>
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/common/Navbar/components/CustomNavLink.tsx